import { AnswerQuestionsMeta, AnswerQuestionsPayload } from 'types/store/AnswerQuestions';
import { createAsyncReducer } from 'utils/Redux';

import { answerQuestionsActions } from '../actions';

export default createAsyncReducer<AnswerQuestionsMeta, AnswerQuestionsPayload>(answerQuestionsActions);
